import Vue from 'vue'
import Vuetify from 'vuetify'
import DaySpanVuetify from 'dayspan-vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import IdleVue from "idle-vue";

import 'vuetify/dist/vuetify.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css'

import fr from 'dayspan-vuetify/src/locales/fr';

import moment from 'moment'
Vue.prototype.moment = moment

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import './../node_modules/bulma/css/bulma.css'; //BULMA CSS
import './../node_modules/bulma-switch/dist/css/bulma-switch.min.css';
import './../node_modules/bulma-badge/dist/css/bulma-badge.min.css';
import './../node_modules/bulma-tooltip/dist/css/bulma-tooltip.min.css';

Vue.use(Vuetify);


// **** **** EXCEL 
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel)


Vue.use(DaySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
});
Vue.$dayspan.addLocales(['fr', 'fr-CA', 'fr-BE', 'fr-CH', 'fr-FR', 'fr-LU', 'fr-MC'], fr);
Vue.$dayspan.setLocale('fr', true);
  
import VueMask from 'v-mask'
Vue.use(VueMask);


 
require('./assets/custom.css'); //CUSTOM CSS

// SET TIMEOUT !
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3600000, // 1 Hour,
  startAtIdle: true
});

// NOTIFICATION
import 'vue-snotify/styles/material.css';
import Snotify from 'vue-snotify'; // 1. Import Snotify
Vue.use(Snotify)

import Print from 'vue-print-nb'
Vue.use(Print);

 // DATE PICKER
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.use(VueFlatPickr);

// ******************************* DEPLOY
// Vue.prototype.$url = 'http://localhost:4000'  
Vue.prototype.$url = 'https://mymeq.herokuapp.com'


Vue.prototype.$colourActive = 'PALETURQUOISE' //'AQUA' //hsla(60, 50%, 50%, 0.22)'
Vue.prototype.$colourGood = 'hsla(90, 20%, 50%, 0.3)'
Vue.prototype.$colourBad = 'hsla(0, 50%, 50%, 0.22)'

Vue.config.productionTip = false

export const bus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
